import { api } from '@/api/http'

// 사용자 설정 조회 — GET api/get_setting?m_id={m_id}
export async function fetchUserSettings(mId) {
  const { data } = await api.get('api/get_setting', { params: { m_id: mId } })
  return data
}

// 사용자 설정 저장 — 레거시 DlgSettings.handleOk 와 동일 패턴
//   GET api/set_setting?m_id={m_id}&json={URI(JSON.stringify(setting))}
//   axios 가 json 을 다시 인코딩하지 않도록 paramsSerializer 직접 지정
export async function saveUserSettings(mId, payload) {
  const json = encodeURIComponent(JSON.stringify(payload || {}))
  const { data } = await api.get('api/set_setting', {
    params: { m_id: mId, json },
    paramsSerializer: { encode: v => v },
  })
  return data
}
